const PACKAGE_UPGRADING = {
  PAGE_TITLE: 'Upgrade Package | Raychat',

  HEADING_TITLE: 'Upgrade Package',
  HEADING_SUBTITLE:
    'You can charge your account by choosing the type and time of the package and continuing the payment process.',

  CHOOSE_PACKAGE: 'Choose Package',
  ACTIVE_PACKAGE: 'Active Package',

  BASE: 'Base',
  COMMERICAL: 'Commerical',
  PREMIUM: 'Premium',
  ALL_FEATURES_OF_PACKAGE: 'All features of',

  MONTHLY: 'Monthly',
  YEARLY: 'Yearly',
  QUARTERLY: 'Quarterly',
  TRIENNIAL: 'Triennial',
  UNIT: '$',

  SEND_OFFICIAL_INVOICE: 'Issuing and sending official invoices',

  CONTINUE_PURCHASE: 'Continue Purchase',

  ACCOUNT_INFO: 'Account Info',

  PACKAGE: 'Package',
  DURATION: 'Duration',
  POSTING: 'Posting',
  TAX: 'Tax',
  USE_CREDIT: 'Using Credit',
  PAYABLE: 'Payable',
  DISCOUNT_CODE: 'Discount Code',
  DISCOUNT_CODE_PERCENT: '% Discount',
  CHECK: 'Check',
  ENTER_DISCOUNT_CODE: 'Enter Discount Code',
  DISCOUNT_CODE_APPLIED: 'Discount code #code# applied',
  DISCOUNT_CODE_APPLIED_PURE: 'Discount code applied',
  CANCEL: 'Cancel',
  CANCEL_CODE: 'Cancel Code',

  PRICE_BEFORE_DISCOUNT: 'Price Before Discount',

  PACKAGE_PRICE: 'Package Price',

  CHOOSE_HOW_TO_RENEWAL: 'Choose How to Renewal',
  CHECK_USER_INFO_HEADER: 'Check information',
  INFO_EDIT_BTN: 'Edit',
  SERVICE: 'Service',

  NATIONAL_CODE: 'National Code',
  PROVINCE: 'Province',
  CITY: 'City',
  PHONE: 'Phone',
  ADDRESS: 'Address',
  COUNTRY: 'Country',
  POSTAL_CODE: 'Postal Code',

  DOWNLOAD_FACTOR_LATER:
    'After payment, you can download your official invoice from the invoices section of your Rich Chat panel.',

  SERVICE_MANUAL_RENEWAL: 'Service Normal Renewal',
  SERVICE_AUTO_RENEWAL: 'Automatically withdrawn from my account every month.',
  SERVICE_AUTO_RENEWAL_DESCRIPTION:
    'In this type of subscription, you no longer need to buy a monthly subscription, the subscription amount will be automatically deducted from your account and your subscription will be renewed.',
  REDIRECT_TO_PAYMENT_GATEWAY: 'Redirect to Payment Gateway',
  GO_TO_PREV_STEP: 'Go back to previous step',

  PAYMENT_SUCCESS_CARD_TITLE: 'Payment has been successful!',
  PAYMENT_FAIL_CARD_TITLE: 'Payment Failed',
  PAYMENT_RESULT_INVOICE_ID_LABEL: 'Invoice ID',
  PAYMENT_RESULT_ID_LABEL: 'Payment ID',
  PAYMENT_RESULT_TOKEN_LABEL: 'Token',
  PAYMENT_RESULT_BACK_LINK_TEXT: 'Back to payment page',
  PAYMENT_RESULT_DETAILS_TITLE: 'Payment details',
  BUY_PACKAGE: 'Buy Package',
  COMPARE: 'Compare',

  SELECTED_PACKAGE: 'Selected Package',
  USE_DISCOUNT: 'Use Discount',
};

export default PACKAGE_UPGRADING;
